import React from 'react';
import styled from '@emotion/styled';

const NoAccess = () => {
  return (
    <StyledContainer>
      <h1>Your account has not been configured</h1>
      <p>Please contact your administrator to use Gritsee</p>
    </StyledContainer>
  );
};

export const StyledContainer = styled.div`
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #595959;
  font-size: medium;
`;

export default NoAccess;
